import React from 'react';

const GuaranteedFit = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_5552_33592)">
      <mask
        id="mask0_5552_33592"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_5552_33592)">
        <path
          d="M22.7096 9.0936C22.8448 9.22881 23.6223 10.0063 23.2843 10.4795C23.2843 10.4795 22.6758 11.4936 22.1688 11.595C21.6617 11.6964 20.8505 11.8316 20.8505 11.8316H20.7829C20.4786 11.8316 20.073 11.764 19.8702 11.3922L19.2279 10.3105C19.0251 9.97247 19.0927 9.60064 19.2955 9.36402C19.4645 9.1274 19.7688 8.99219 20.0392 8.99219H22.2364C22.2364 8.99219 22.5744 8.99219 22.6758 9.0936H22.7096Z"
          fill="#F3FCFF"
        />
        <path
          d="M19.2949 11.7305L18.6526 10.6488C18.3484 10.108 18.3822 9.4319 18.754 8.92486C19.0583 8.51922 19.5315 8.31641 20.0385 8.31641H22.2019C22.4047 8.31641 22.8442 8.31641 23.1484 8.62063C24.2639 9.73612 24.0611 10.4798 23.8244 10.8516C23.5878 11.2573 22.9794 12.1361 22.2695 12.2713C21.7625 12.3727 20.9512 12.508 20.9174 12.508H20.647C20.0723 12.508 19.5315 12.2037 19.2611 11.7305H19.2949ZM22.3033 9.66852H20.0723C20.0047 9.66852 19.9033 9.70232 19.8695 9.76993C19.8695 9.76993 19.8019 9.87134 19.8695 9.97274L20.5118 11.0882C20.5794 11.1896 20.7146 11.1896 20.7146 11.1896H20.7822C20.7822 11.1896 21.5597 11.0544 22.0329 10.9868C22.1681 10.9192 22.4723 10.5474 22.709 10.2094C22.7766 10.108 22.5061 9.66852 22.3033 9.66852Z"
          fill="#004C80"
        />
        <path
          d="M1.31395 9.0936C1.41535 8.99219 1.75338 8.99219 1.75338 8.99219H3.95057C4.22099 8.99219 4.52521 9.1274 4.69423 9.36402C4.89704 9.60064 4.96465 9.97247 4.76183 10.3105L4.11958 11.3922C3.91676 11.764 3.51113 11.8316 3.2069 11.8316H3.1393C3.1393 11.8316 2.32803 11.6964 1.82099 11.595C1.31395 11.4936 0.705495 10.4795 0.705495 10.4795C0.367467 10.0063 1.14493 9.22881 1.28014 9.0936H1.31395Z"
          fill="#F3FCFF"
        />
        <path
          d="M4.72743 11.7305C4.45701 12.2037 3.91616 12.508 3.34151 12.508H3.07109C3.07109 12.508 2.22602 12.3727 1.71898 12.2713C1.00912 12.1361 0.400668 11.2573 0.164048 10.8516C-0.0725718 10.4798 -0.275389 9.73612 0.840104 8.62063C1.14433 8.31641 1.58377 8.31641 1.78658 8.31641H3.94996C4.45701 8.31641 4.93025 8.51922 5.23447 8.92486C5.6063 9.4319 5.6401 10.108 5.33588 10.6488L4.69363 11.7305H4.72743ZM1.24574 10.2094C1.48236 10.5474 1.78658 10.9192 1.92179 10.9868C2.39503 11.0544 3.1725 11.1896 3.1725 11.1896H3.2401C3.2401 11.1896 3.37532 11.1896 3.44292 11.0882L4.08518 9.97274C4.15278 9.87134 4.08518 9.76993 4.08518 9.76993C4.08518 9.70232 3.94996 9.66852 3.88236 9.66852H1.65137C1.41475 9.66852 1.17813 10.108 1.24574 10.2094Z"
          fill="#004C80"
        />
        <path
          d="M20.987 11.5947V16.1581C20.987 16.8341 20.48 17.544 19.6687 17.544H4.32222C3.51095 17.544 3.00391 16.8341 3.00391 16.1581V11.5947C3.00391 11.4257 3.00391 11.2567 3.10531 11.0877V11.0201L5.3025 5.74681C5.50531 5.30738 5.94475 4.93555 6.4856 4.93555H11.9955H17.5053C18.0462 4.93555 18.4856 5.34118 18.6884 5.78062L20.8856 11.0539V11.1215C20.9532 11.2905 20.987 11.4595 20.987 11.6285V11.5947Z"
          fill="#F3FCFF"
        />
        <path
          d="M21.5281 10.8519L19.2971 5.47727C18.9591 4.6998 18.2493 4.22656 17.4718 4.22656H6.51967C5.74221 4.22656 5.03235 4.6998 4.69432 5.47727L2.46334 10.8519C2.36193 11.0885 2.32812 11.359 2.32812 11.5956V16.159C2.32812 17.1392 3.07179 18.2209 4.32249 18.2209H19.669C20.9197 18.2209 21.6633 17.1392 21.6633 16.159V11.5956C21.6633 11.359 21.6633 11.0885 21.5281 10.8519ZM20.345 11.3252V16.159C20.345 16.4294 20.1422 16.8688 19.7028 16.8688H4.28869C3.84925 16.8688 3.64644 16.4294 3.64644 16.159V11.2575L5.84362 5.98431C5.91122 5.78149 6.11404 5.57868 6.41827 5.57868H17.5732C17.8774 5.57868 18.0802 5.78149 18.1478 5.98431L20.345 11.2575V11.3252Z"
          fill="#004C80"
        />
        <path
          d="M9.39269 12.8455C9.5955 12.9132 9.62931 12.9808 9.66311 13.0484L10.3392 14.2991C10.5082 14.5695 10.2716 14.9751 9.93353 14.9413L4.7279 14.4681C4.52508 14.4681 4.32227 14.2653 4.32227 14.0286V12.2371C4.32227 11.9667 4.55889 11.7639 4.86311 11.8315L9.39269 12.8455Z"
          fill="#004C80"
        />
        <path
          d="M19.1277 11.8315C19.3981 11.7639 19.6686 11.9667 19.6686 12.2371V14.0286C19.6686 14.2653 19.4657 14.4681 19.2629 14.4681L14.0573 14.9413C13.7193 14.9413 13.4826 14.5695 13.6517 14.2991L14.3277 13.0484C14.3277 12.9808 14.3953 12.9132 14.5981 12.8455L19.1277 11.8315Z"
          fill="#004C80"
        />
        <path
          d="M5.20237 9.66815L6.48688 6.55829C6.52068 6.42307 6.65589 6.35547 6.7573 6.35547H17.2362C17.3376 6.35547 17.4728 6.42307 17.5066 6.55829L18.7911 9.66815C18.8925 9.90476 18.7911 10.209 18.5207 10.209H5.4728C5.23618 10.209 5.06716 9.93857 5.20237 9.66815Z"
          fill="#004C80"
        />
        <path
          d="M7.12516 17.5449V19.3703C7.12516 19.8097 6.78713 20.1477 6.34769 20.1477H4.15051C3.71108 20.1477 3.37305 19.8097 3.37305 19.3703V17.5449H7.15896H7.12516Z"
          fill="#F3FCFF"
        />
        <path
          d="M6.34797 20.8573H4.15079C3.33952 20.8573 2.69727 20.215 2.69727 19.4038V16.9023H7.83529V19.4038C7.83529 20.215 7.19304 20.8573 6.38177 20.8573H6.34797ZM4.01558 18.2207V19.3699C4.01558 19.4376 4.04938 19.4714 4.11698 19.4714H6.31417C6.38177 19.4714 6.41558 19.4714 6.41558 19.3699V18.2207H3.98177H4.01558Z"
          fill="#004C80"
        />
        <path
          d="M20.6486 17.5449V19.3703C20.6486 19.8097 20.3106 20.1477 19.8711 20.1477H17.6739C17.2345 20.1477 16.8965 19.8097 16.8965 19.3703V17.5449H20.6824H20.6486Z"
          fill="#F3FCFF"
        />
        <path
          d="M19.8714 20.8573H17.6742C16.863 20.8573 16.2207 20.215 16.2207 19.4038V16.9023H21.3587V19.4038C21.3587 20.215 20.7165 20.8573 19.9052 20.8573H19.8714ZM17.539 18.2207V19.3699C17.539 19.4376 17.539 19.4714 17.6404 19.4714H19.8376C19.9052 19.4714 19.939 19.4714 19.939 19.3699V18.2207H17.5052H17.539Z"
          fill="#004C80"
        />
        <path
          d="M15.9508 15.6516C19.3987 15.6516 22.2043 12.8459 22.2043 9.39805C22.2043 5.95017 19.3987 3.14453 15.9508 3.14453C12.5029 3.14453 9.69727 5.95017 9.69727 9.39805C9.69727 12.8459 12.5029 15.6516 15.9508 15.6516Z"
          fill="#FF7C1F"
        />
        <path
          d="M14.5994 12.3718C14.3965 12.3718 14.1599 12.3042 13.9909 12.1352L12.0641 10.2084C11.7937 9.93797 11.7937 9.53233 12.0641 9.26191C12.3346 8.99149 12.7402 8.99149 13.0106 9.26191L14.5994 10.8506L18.8585 6.59149C19.1289 6.32107 19.5346 6.32107 19.805 6.59149C20.0754 6.86191 20.0754 7.26754 19.805 7.53797L15.174 12.169C14.9374 12.4056 14.5994 12.3718 14.5994 12.3718Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_5552_33592">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GuaranteedFit;
